import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertInfo, AlertService, AlertType } from 'src/app/Services/Alert/alert.service';

@Component({
  standalone: false,
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnDestroy {
  private readonly alertIdSubject = new BehaviorSubject<string | null>(null);
  readonly alertVm$: Observable<{ alert: AlertInfo; iconName: string; alertClass: string } | null>;

  @Input() set alertId(value: string) {
    this.alertIdSubject.next(value ?? null);
  }
  @Input() small = false;

  constructor(private alertService: AlertService) {
    this.alertVm$ = combineLatest([this.alertService.alert$, this.alertIdSubject]).pipe(
      map(([alertInfo, alertId]) => {
        if (!alertInfo) {
          return null;
        }

        const isMatch =
          (alertInfo.targetId == null && alertId == null) ||
          (alertInfo.targetId != null && alertId != null && alertInfo.targetId === alertId);

        if (!isMatch) {
          return null;
        }

        const iconName = `assets/images/ontario-icon-alert-${this.mapIcon(alertInfo.type)}.svg`;
        const alertClass = `ontario-alert--${this.mapClass(alertInfo.type)}`;
        return { alert: alertInfo, iconName, alertClass };
      })
    );
  }

  mapIcon(type: AlertType): string {
    switch (type) {
      case AlertType.Info:
        return 'information';
      case AlertType.Warning:
        return 'warning';
      case AlertType.Success:
        return 'success';
      case AlertType.Error:
        return 'error';
    }
  }

  mapClass(type: AlertType): string {
    switch (type) {
      case AlertType.Info:
        return 'informational';
      case AlertType.Warning:
        return 'warning';
      case AlertType.Success:
        return 'success';
      case AlertType.Error:
        return 'error';
    }
  }

  ngOnDestroy() {
    this.alertIdSubject.complete();
  }

  clearAlert() {
    this.alertService.clearAlert();
  }
}
